import React, { useRef, useState, useEffect } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Switch, Route, withRouter, Link, useHistory } from "react-router-dom";
import axios from 'axios'
import OverviewSearch from '../OverviewSearch/OverviewSearch'
import InteractiveMap from '../InteractiveMap/InteractiveMap'
import OverviewDashboard from '../OverviewDashboard/OverviewDashboard'
import AllCounties from '../AllCounties/AllCounties'
import AllCommodities from '../AllCommodities/AllCommodities'
import RegionOverview from '../RegionOverview/RegionOverview'
import PrintButton from '../PrintButton/PrintButton'
import CountyOverview from '../CountyOverview/CountyOverview'
import CommodityOverview from '../CommodityOverview/CommodityOverview'
import './Overview.scss'

const arrowStyle = {
    background: 'url(/wp-content/plugins/react-plugin/app/src/assets/images/icons/long-arrow-alt-right-blue.svg) no-repeat 100% center'
};
function Overview(props) {

    const [showMap, setShowMap] = useState(false)
    const [mapData, setMapData] = useState()
    const [searchType, setSearchType] = useState('county')
    const [index, setIndex] = useState(0)
    const [mapWidth, setMapWidth] = useState(0)
    const [stateData, setStateData] = useState()
    const [stateDataLoaded, setStateDataLoaded] = useState(false)
    const ref = useRef(null);
    const history = useHistory()
    const handleToggleMap = () => {
        setShowMap(!showMap)
    }
    useEffect(() => {

        if (props.location?.index) {
            setIndex(props.location?.index)
        }

        const getMapWidth = () => {
            let width = ref.current ? ref.current.offsetWidth : 0;
            width = width > 430 ? 430 : width;

            setMapWidth(width);
        }
        getMapWidth();

        (() => {
            axios.get('/wp-json/state/v1/all')
                .then(res => res.data)
                .then(data => {
                    setStateData(data[0])
                    setStateDataLoaded(true)
                })
                .catch(e => e);
        })();

        window.addEventListener('resize', getMapWidth)

        return () => {
            window.removeEventListener('resize', getMapWidth)
        }

    }, [mapData, index, props.location?.index, history]);

    return (
        <div className='overview-container'>
            <div className='left-container'>
                <div className='inner-container'>
                    <div className='search-container'>
                        <OverviewSearch sendToParent={setSearchType} />
                        <div className="all-links">
                            {
                                searchType === 'county' ?
                                    <Link to={{
                                        pathname: '/overview',
                                        index: 1
                                    }}> See all Counties <span className="arrow-icon" style={arrowStyle}></span></Link>
                                    :
                                    <Link to={{
                                        pathname: '/overview',
                                        index: 2
                                    }} > See all Commodities <span className="arrow-icon" style={arrowStyle}></span></Link>
                            }
                        </div>
                    </div>
                    <span>OR</span>
                    <div className={showMap ? 'map-container show-map' : 'map-container'} >
                        <p className='map-title' onClick={handleToggleMap}>Open map</p>
                        <div className='map' style={{ width: '100%' }} ref={ref}>
                            <InteractiveMap width={mapWidth} toChild={mapData} sendToParent={setMapData} />

                        </div>

                    </div>
                </div>
            </div>
            <div className='right-container'>
                <div className='inner-container'>
                    <div className='mode-selection'>
                        <>
                            <Switch>
                                <Route exact path='/overview'>
                                    <h1>Local Economic Impact - State of Georgia</h1>

                                    <Tabs selectedIndex={index} onSelect={index => {
                                        setIndex(index)
                                        history.push({ pathname: '/overview', index })
                                    }}>
                                        <TabList>
                                            <Tab>Overview</Tab>
                                            <Tab>All Counties {`(${stateData?.TotalCounties})`}</Tab>
                                            <Tab>All Commodities {`(${stateData?.TotalCommodities})`}</Tab>
                                        </TabList>
                                        <TabPanel>
                                            <PrintButton />
                                            <OverviewDashboard data={stateData} dataLoaded={stateDataLoaded} />
                                        </TabPanel>
                                        <TabPanel>
                                            <AllCounties />
                                        </TabPanel>
                                        <TabPanel>
                                            <AllCommodities />
                                        </TabPanel>
                                    </Tabs>
                                </Route>
                                <Route exact path='/overview/county'>
                                    <CountyOverview countyName={props.location.state?.countyName ? props.location.state?.countyName : localStorage.getItem("county-name")} countyKey={props.location.state?.urlKey ? props.location.state?.urlKey : localStorage.getItem("county_url")} />
                                </Route>
                                <Route exact path='/overview/commodity'>
                                    <CommodityOverview commodityName={props.location.state?.commodityName ? props.location.state?.commodityName : 'Miscellaneous Articles Of Base Metal'} commodityKey={props.location.state?.urlKey ? props.location.state?.urlKey : 'miscellaneous-articles-of-base-metal'} />
                                </Route>
                                <Route exact path='/overview/region'>
                                    <RegionOverview regionName={props.location.state?.regionName ? props.location.state?.regionName : localStorage.getItem("region-name")} regionKey={props.location.state?.urlKey ? props.location.state?.urlKey : localStorage.getItem("region_id")} />
                                </Route>
                            </Switch>


                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Overview)